
const url = '/apis/noAuth/standard';
export default API => ({
    
    getStandardCategoryTree({ params, data }) {
        return API({
            url:`${url}/getAllFirstCategoryTree?t=${Date.now()}`,
            params, 
            data
        });
    },

    
    getStandardList({ params, data }) {
        return API({ url: `${url}/getStandardList?t=${Date.now()}`, method:'post', params, data });
    },

    
    getStandardDetail(id) {
        return API({url:`${url}/getStandardById?id=${id}&t=${Date.now()}`});
    }
})